/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { NFTTicket, NFTTicketInterface } from "../NFTTicket";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "WETH_ADDRESS_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "controllerMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
    ],
    name: "getSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
    ],
    name: "getTicketData",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "contractAddress",
            type: "address",
          },
          {
            internalType: "uint32",
            name: "startDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mintStartDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mintEndDate",
            type: "uint32",
          },
          {
            internalType: "uint96",
            name: "mintPrice",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "maxMintAmountPlusOne",
            type: "uint16",
          },
          {
            internalType: "uint96",
            name: "redeemPrice",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool",
          },
        ],
        internalType: "struct NFTTicket.Ticket",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "controller",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "contractAddress",
            type: "address",
          },
          {
            internalType: "uint32",
            name: "startDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mintStartDate",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mintEndDate",
            type: "uint32",
          },
          {
            internalType: "uint96",
            name: "mintPrice",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "maxMintAmountPlusOne",
            type: "uint16",
          },
          {
            internalType: "uint96",
            name: "redeemPrice",
            type: "uint96",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool",
          },
        ],
        internalType: "struct NFTTicket.Ticket",
        name: "ticketData_",
        type: "tuple",
      },
    ],
    name: "initializeTicket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "active_",
        type: "bool",
      },
    ],
    name: "updateActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "endDate_",
        type: "uint32",
      },
    ],
    name: "updateEndDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "maxMintAmountPlusOne_",
        type: "uint16",
      },
    ],
    name: "updateMaxMintAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "maxSupply_",
        type: "uint16",
      },
    ],
    name: "updateMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "mintEndDate_",
        type: "uint32",
      },
    ],
    name: "updateMintEndDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint96",
        name: "mintPrice_",
        type: "uint96",
      },
    ],
    name: "updateMintPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "mintStartDate_",
        type: "uint32",
      },
    ],
    name: "updateMintStartDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "paused_",
        type: "bool",
      },
    ],
    name: "updatePaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint96",
        name: "redeemPrice_",
        type: "uint96",
      },
    ],
    name: "updateRedeemPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "startDate_",
        type: "uint32",
      },
    ],
    name: "updateStartDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId_",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type NFTTicketConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NFTTicketConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NFTTicket__factory extends ContractFactory {
  constructor(...args: NFTTicketConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    WETH_ADDRESS_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NFTTicket> {
    return super.deploy(WETH_ADDRESS_, overrides || {}) as Promise<NFTTicket>;
  }
  getDeployTransaction(
    WETH_ADDRESS_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(WETH_ADDRESS_, overrides || {});
  }
  attach(address: string): NFTTicket {
    return super.attach(address) as NFTTicket;
  }
  connect(signer: Signer): NFTTicket__factory {
    return super.connect(signer) as NFTTicket__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NFTTicketInterface {
    return new utils.Interface(_abi) as NFTTicketInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTTicket {
    return new Contract(address, _abi, signerOrProvider) as NFTTicket;
  }
}
